const downloadFile = async (type: string): Promise<void> => {
  const response = await window.fetch(`/api/bff/files/${type}`);

  if (!response.ok) {
    throw new Error('Failed to download PDF');
  }

  const contentDisposition = response.headers.get('Content-Disposition');
  let filename = 'file.txt'; // fallback
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (filenameMatch) {
      /* eslint-disable */
      filename = filenameMatch[1];
    }
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export {
  downloadFile
};
